import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Textarea } from "@/components/ui/textarea";
import { MessageSquare } from 'lucide-react';

// A reviewer's overall comment on the appraisal: editable when onChange is
// passed, otherwise read-only and hidden if there's nothing to show.
function FinalCommentCard({
  title,
  description = null,
  comment = '',
  onChange = null,
}) {
  if (!onChange && !comment) return null;

  return (
    <Card className="border-primary/30">
      <CardHeader className="bg-primary/5 border-b">
        <CardTitle className="text-base text-primary flex items-center gap-2">
          <MessageSquare className="h-5 w-5" /> {title}
        </CardTitle>
        {description && (
          <CardDescription className="text-muted-foreground">{description}</CardDescription>
        )}
      </CardHeader>
      <CardContent className="p-6">
        {onChange ? (
          <Textarea
            placeholder="Share your overall comment on this appraisal..."
            className="min-h-[120px]"
            value={comment}
            onChange={(e) => onChange(e.target.value)}
          />
        ) : (
          <p className="text-sm text-muted-foreground italic whitespace-pre-wrap">"{comment}"</p>
        )}
      </CardContent>
    </Card>
  );
}

export default FinalCommentCard;
